export default ".card-model-from-attestation-header {\n  display: flex;\n  justify-content: flex-end;\n}";